import { useEffect, useState } from 'react';
import '../../dmView/style/App.css';

const DeathSaveToken = ({type, addCheck, i, empty=false}) => {
    let color;
    let path;
    if(type === "success") {
        color = "#66ae66"
        path = "M 7 12 L 10 15 L 17 8"
    } else {
        color = "#c43d3dff"
        path = "M 8 8 L 16 16 M 16 8 L 8 16"
    }


    return (
        <svg className="checkCircle" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => addCheck(i, type)}>
            <circle cx="12" cy="12" r="11" stroke={color} strokeWidth="2" fill={empty ? "#ecececff" : "white"}/>
            {!empty &&
                <path d={path} stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            }
        </svg>
    )
}

const DeathSaves = ({creatueGuid, pass, fail, socket=undefined}) => {
    const [saveCount, setSaveCount] = useState(pass);
    const [failCount, setFailCount] = useState(fail);
    

    useEffect(() => {
        setSaveCount(pass);
        setFailCount(fail);
    }, [pass, fail]);

    const savesArr = [];
    const failsArr = [];

    const addCheck = (i, type) => { 
        if(socket) {
            let newValue;
            if(type === "success") {
                newValue = i < saveCount ? saveCount - 1 : saveCount + 1;
                setSaveCount(newValue)
                socket.emit("creatureDeathSaveChange", newValue, "success", creatueGuid)
            } else if(type === "fails") {
                newValue = i < failCount ? failCount - 1 : failCount + 1;
                setFailCount(newValue)
                socket.emit("creatureDeathSaveChange", newValue, "fails", creatueGuid)
            }
        }

    }

    let sCount = saveCount;
    let fCount = failCount;

    for (let i = 0; i < 3; i++) {
        savesArr.push(
            <div className='saveContainer'>
                {sCount > 0
                    ? <DeathSaveToken type="success" addCheck={addCheck} i={i} />
                    : <DeathSaveToken type="success" addCheck={addCheck} i={i} empty={true}/>
                }           
            </div>

        );
        
        failsArr.push(
            <div className='saveContainer'>
                {fCount > 0 
                    ? <DeathSaveToken type="fails" addCheck={addCheck} i={i} />
                    : <DeathSaveToken type="fails" addCheck={addCheck} i={i} empty={true}/>
                }
            </div>
        );

        sCount--;
        fCount--;
    }

    return (
        <div className="deathSavesGrid">
            <div className='savesRow'>
                {savesArr}
            </div>
            <div className='savesRow'>
                {failsArr}
            </div>
            
        </div>
    );
};

export default DeathSaves;